<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('会员等级名称')" prop="levelName">
        <a-input v-model="form.levelName" :placeholder="$t('请输入')+$t('会员等级名称')">
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['levelName']"
            input-type="input"
            table-name="user_user_level"
            table-field="levelName"
            :field-value="form.levelName"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('升级所需值')" prop="upgradeScore">
        <a-input-number v-model="form.upgradeScore" style="width: 100%" :min="0" :max="21474836" :precision="0" :placeholder="$t('请输入')+$t('升级所需积分')"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('考核周期(月)')" prop="periodMonth">
        <a-input-number v-model="form.periodMonth" style="width: 100%" :min="1" :max="120" :precision="0" :placeholder="$t('请输入')+$t('考核周期(月)')"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('升级策略')" prop="upgradePolicy">
        <a-select :placeholder="$t('请选择')+$t('审核状态')" v-model="form.upgradePolicy" style="width: 100%" allow-clear>
          <a-select-option v-for="(item, index) in customDict.LevelUpgradeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('保级所需值')" prop="keepScore">
        <a-input-number v-model="form.keepScore" style="width: 100%" :min="0" :max="21474836" :precision="0" :placeholder="$t('请输入')+$t('保级所需值')"/>
      </a-form-model-item>
      <a-form-model-item prop="discount">
        <span slot="label" >
          <a-tooltip>
           折扣<template slot="title">取值范围0-1 , 比如,0.8 即 8折</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.discount" style="width: 100%" :min="0.01" :max="1" :step="0.01" :placeholder="$t('请输入')+'折扣'"/>
      </a-form-model-item>
<!--      <a-form-model-item label="能查看分类数" prop="categoryNum">
        <a-input-number v-model="form.categoryNum" style="width: 100%"
                 :placeholder="$t('请输入')+'能查看分类数'"/>
      </a-form-model-item>-->
      <a-form-model-item label="等级图片" prop="picture">
        <oss-upload-single :height="100" :width="100"  v-model="form.picture" prefix="user" type="img"/>
        <span>推荐尺寸 351 x 220</span>
      </a-form-model-item>
      <a-form-model-item label="等级图标" prop="icon">
        <oss-upload-single :height="100" :width="100"  v-model="form.icon" prefix="user" type="img"/>
        <span>推荐尺寸 75 x 22</span>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl"/>
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getLevel, addLevel, updateLevel} from '@/api/user/level'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from '@/components/Editor'
import {translation} from "@/api/tool/common";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    OssUploadSingle,
    LocaleFieldButton,
    CustomDictTag,
    Editor
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('会员等级名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          key: 'name'
        }, {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'name' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 表单参数
      form: {
        id: null,
        levelName: null,
        categoryNum :0,
        sort: null,
        picture: null,
        upgradeScore: null,
        periodMonth: null,
        upgradePolicy: null,
        keepScore: null,
        discount: null,
        lotteryTimes: null,
        categoryFreeDay: 0,
        freightFree: null,

        birthdayGift: null,

        birthdayGiftContent: null,

        upgradeGift: null,

        upgradeGiftContent: null,

        createTime: null,

        remark: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        levelName: [
          {required: true, message: this.$t('会员等级名称') + this.$t('不能为空'), trigger: 'blur'}
        ],
        sort: [
          {required: true, message: this.$t('会员等级排序，1最低，从小到大升级') + this.$t('不能为空'), trigger: 'blur'}
        ],
        upgradeScore: [
          {required: true, message: this.$t('升级所需积分') + this.$t('不能为空'), trigger: 'blur'}
        ],
        periodMonth: [
          {required: true, message: this.$t('考核周期(月)') + this.$t('不能为空'), trigger: 'blur'}
        ],
        upgradePolicy: [
          {required: true, message: this.$t('升级策略') + this.$t('不能为空'), trigger: 'change'}
        ],
        keepScore: [
          {required: true, message: this.$t('保级所需值') + this.$t('不能为空'), trigger: 'blur'}
        ],
        discount: [
          {required: true, message: this.$t('折扣') + this.$t('不能为空'), trigger: 'blur'}
        ],
        categoryNum: [
          {required: true, message: '分类数' + this.$t('不能为空'), trigger: 'blur'}
        ],
        lotteryTimes: [
          {required: true, message: this.$t('每日抽奖赠送的每天的抽奖次数') + this.$t('不能为空'), trigger: 'blur'}
        ],
        freightFree: [
          {required: true, message: this.$t('是否免运费，1为是，0为否') + this.$t('不能为空'), trigger: 'blur'}
        ],
        birthdayGift: [
          {required: true, message: this.$t('是否有生日礼包权益，1为有，0为没有') + this.$t('不能为空'), trigger: 'blur'}
        ],
        categoryFreeDay: [
          {required: true, message: this.$t('免费天数') + this.$t('不能为空'), trigger: 'blur'}
        ],

      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        levelName: null,
        sort: null,
        picture: null,
        upgradeScore: null,
        periodMonth: null,
        upgradePolicy: null,
        keepScore: null,
        discount: null,
        categoryFreeDay: 0,
        lotteryTimes: null,
        freightFree: null,
        birthdayGift: null,
        birthdayGiftContent: null,
        upgradeGift: null,
        upgradeGiftContent: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },

    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },
    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLevel({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateLevel(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addLevel(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
